import { axiosPost } from "../options/header";
import { handleSSEStream } from "../utils/sseStream";

/**
 * API caller for Legal RAG Assistant integration
 * Conversation history stored in frontend localStorage
 */
export default {
  /**
   * Query the legal RAG assistant with streaming response
   * @param {string} question - The legal question
   * @param {Array} conversationHistory - Previous conversation messages
   * @param {Array} previousCitations - Previous citations
   * @param {Function} onChunk - Callback for each chunk (type, data)
   * @param {Function} onComplete - Callback when stream completes
   * @param {Function} onError - Callback for errors
   */
  async queryLegalRagStream(question, conversationHistory = [], previousCitations = [], onChunk, onComplete, onError) {
    await handleSSEStream(
      process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/ai/legal-rag/query",
      { question, conversationHistory, previousCitations },
      onChunk,
      onComplete,
      onError
    );
  },

  /**
   * Query the legal RAG assistant (non-streaming - deprecated, use queryLegalRagStream)
   * @param {string} question - The legal question
   * @param {Array} conversationHistory - Previous conversation messages
   * @param {Array} previousCitations - Previous citations
   * @returns {Promise} Response with answer and citations
   */
  async queryLegalRag(question, conversationHistory = [], previousCitations = []) {
    try {
      return await axiosPost(
        process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/ai/legal-rag/query",
        {
          question,
          conversationHistory,
          previousCitations
        }
      );
    } catch (err) {
      console.error('Legal RAG query failed:', err);
      throw err;
    }
  }
};
